import { mapRequestStatusFiltersToServerFilters } from '../../helpers/statusHelpers';
import { Modify, OneOrArray } from '../../types';
import {
  ActivityFilter,
  CommentFilter,
  RFIFilter,
  RfiFilterStatus,
  RFIFilterWithServerStatuses,
  RfiStatus,
} from '../types';

type FilterTuple = [string, string];
type FilterValue = string | number | boolean | readonly string[];

const isEmptyArray = (array: unknown) => Array.isArray(array) && !array.length;

export const getFlatParams = (value: FilterValue): string =>
  Array.isArray(value) ? value.join(',') : value.toString();

const getEntityIdOrListFilterTuple = (property: string, value: FilterValue): [string, string] => [
  `filter[${property}]`,
  getFlatParams(value),
];

type Filter = Partial<RFIFilter | CommentFilter | ActivityFilter>;
const isRfiFilter = (filter: Filter): filter is Partial<RFIFilter> =>
  !!((filter as Partial<RFIFilter>)?.id || (filter as Partial<RFIFilter>)?.status);

export const constructFilterParamList = (filter: Filter): FilterTuple[] => {
  if (isRfiFilter(filter)) {
    return getParamList(handleRfiStatusFilter(filter));
  }

  return getParamList(filter);
};

const handleRfiStatusFilter = (filterBy: RFIFilter): RFIFilterWithServerStatuses => {
  const isFilterRfisByAllStatuses = filterBy.id && !filterBy.status;
  const status = isFilterRfisByAllStatuses
    ? mapRequestStatusFiltersToServerFilters([RfiFilterStatus.All])
    : mapRequestStatusFiltersToServerFilters(filterBy.status);

  return {
    ...(filterBy as RFIFilterWithServerStatuses),
    ...(status && { status }),
  };
};

const getParamList = (filter: Modify<Filter, { status?: OneOrArray<RfiStatus> }>): FilterTuple[] =>
  Object.entries(filter)
    .map(([property, value]) =>
      value !== undefined && !isEmptyArray(value)
        ? getEntityIdOrListFilterTuple(property, value)
        : null,
    )
    .filter((tuple): tuple is FilterTuple => tuple !== null);
